import yup from '../../../validator';
export const getDiscordWebhookUrlSchema = () => yup.object({
    discordWebhookUrl: yup
        .string()
        .label('Discord Webhook URL')
        .url()
        .matches(/^https:\/\/discord.com\/api\/webhooks\/\d+\/.*$/, { excludeEmptyString: true }),
});
